<template>
  <div
    :class="active ? 'vd-VendorsMap_Vendor-active' : 'vd-VendorsMap_Vendor-inactive'"
    @click="onSelectVendor(vendor)"
  >
    <div class="row align-items-center">
      <div class="col-4">
        <img :src="vendor.image" :alt="vendor.name" class="rounded-circle img-fluid" />
      </div>
      <div class="col-20">
        <p class="h6 mb-0">
          {{ vendor.name }}
        </p>
        <p v-if="vendor.subline" class="text-muted text-xs mb-0 mt-1">
          {{ vendor.subline }}
        </p>
        <a
          v-if="showLink"
          :href="vendor.path"
          class="badge badge-pill badge-gray-300 px-2 h6 mt-2 mb-0"
        >
          {{ linkText }}
          <span class="fa fa-caret-right"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vendor: {
      type: Object,
      required: true,
    },
    linkText: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
    showLink: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onSelectVendor(vendor) {
      this.$emit("select-vendor", vendor);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.vd-VendorsMap_VendorTile {
  cursor: pointer;
  box-shadow: $box-shadow-sm;

  &:hover {
    box-shadow: $box-shadow-sm-hover;
  }
}

.vd-VendorsMap_Vendor-inactive {
  opacity: 0.5;
}
</style>
